// React and Headless UI imports
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Fragment } from "react";

// Icon imports
import DotsVerticalIcon from "@icons/dots-vertical.svg?react";

import Divider from "./Divider";

export interface MenuItemConfig {
    id: string;
    content: React.ReactNode;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    onClick: () => void;
    className?: string;
    showDivider?: boolean;
    disabled?: boolean;
}

export interface ThreeDotMenuProps {
    menuItems: MenuItemConfig[];
    buttonClassName?: string;
}

export const ThreeDotMenu = ({ menuItems, buttonClassName }: ThreeDotMenuProps) => {
    return (
        <Menu as="div" className="relative inline-block text-left">
            <MenuButton
                className={
                    buttonClassName ||
                    "ring-1 ring-inset ring-gray-300 rounded-md px-2 py-2 bg-white text-gray-700 hover:text-gray-900 hover:bg-gray-100 focused-inset"
                }
                onClick={(e) => e.stopPropagation()}
            >
                <span className="sr-only">Open options</span>
                <DotsVerticalIcon className="h-5 w-5 text-gray-700" />
            </MenuButton>
            <MenuItems
                anchor={{
                    to: "bottom end",
                    gap: 4,
                }}
                className="z-50 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                data-menu-items
            >
                <div className="py-1">
                    {menuItems.map((item, index) => (
                        <Fragment key={item.id}>
                            <MenuItem>
                                {({ focus }) => (
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!item.disabled) {
                                                item.onClick();
                                            }
                                        }}
                                        disabled={item.disabled}
                                        className={`${focus ? "bg-gray-100" : ""} ${
                                            item.className || "text-gray-700"
                                        } ${
                                            item.disabled ? "opacity-50 cursor-not-allowed" : ""
                                        } group flex w-full items-center px-4 py-2 text-sm`}
                                    >
                                        <item.icon className="mr-3 h-4 w-4" />
                                        {item.content}
                                    </button>
                                )}
                            </MenuItem>
                            {item.showDivider && index < menuItems.length - 1 && <Divider className="my-1" />}
                        </Fragment>
                    ))}
                </div>
            </MenuItems>
        </Menu>
    );
};
